import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
@Component({
	selector: 'button-bar',
	templateUrl: './button-bar.component.html',
	styleUrls: ['./button-bar.component.scss']
})

export class ButtonBarComponent implements OnInit {

	@Input() items: { label: string; value: any }[];
	@Input() extraItems: { label: string; value: any }[];
	@Input() includeAddButton = false;
	@Input() addLabel = '';
	@Input() theme?: string;
	@Output() onMouseOverItem: EventEmitter<any> = new EventEmitter<any>();
	@Output() onItemSelected: EventEmitter<any> = new EventEmitter<any>();
	@Output() onOpened: EventEmitter<any> = new EventEmitter<any>();
	@Output() onClosed: EventEmitter<any> = new EventEmitter<any>();

	showItems = false;
	itemOpacity = 1;

	constructor() {
	}

	ngOnInit() {
	}

	onItemClicked(item: any) {
		this.onItemSelected.emit(item);
		this.close();
	}

	onItemHover(item: any) {
		this.onMouseOverItem.emit(item);
	}

	onAddButtonClick() {
		this.open();
	}

	onAddLabelClick() {
		this.open();
	}

	public close() {
		this.showItems = false;
		this.onClosed.emit();
	}

	public open() {
		this.showItems = true;
		this.itemOpacity = 0;
		setTimeout(() => {
			this.itemOpacity = 1;
			this.onOpened.emit();
		});
	}
}
